import {useState} from 'react';
import Image from 'next/image'
import React from 'react'
import { useRouter } from 'next/router';

export default function OurClientAnimationBox(
{bg,clientLogo,hashTag,country,description,clientName,link}) 
{
    const [isMouseOver,setIsMouseOver]=useState(false);
    const {push}= useRouter();
    
    const handleCardClick = (e) => {
        e.preventDefault();
        if (link) {
            push(link);
        }
    };

  return (
  <div
  className="group relative overflow-hidden rounded-hidden rounded-3xl border border-gray-300/50 shadow-xl hover:shadow-2xl transition-all duration-500 bg-gradient-to-br from-white/50 to-gray-50/30 backdrop-blur-sm cursor-pointer"
  onMouseEnter={() => setIsMouseOver(true)}
  onMouseLeave={() => setIsMouseOver(false)}
  onClick={handleCardClick}
>
  {/* Main Card Content */}
  <div className="grid h-full rounded-3xl">
    {/* Image Section */}
    <div className="relative overflow-hidden rounded-t-3xl h-48 group-hover:h-52 transition-all duration-500">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 via-purple-500/15 to-indigo-500/25 group-hover:from-blue-500/30 group-hover:via-purple-500/20 group-hover:to-indigo-500/35 transition-all duration-500 z-10" />
      <Image
        src={bg}
        alt="client background"
        fill
        className={`object-cover transition-transform duration-700 ${isMouseOver ? 'scale-110' : 'scale-100'}`}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent z-10" />
    </div>

    {/* Text Section */}
    <div className="bg-gradient-to-b from-transparent to-white/40 rounded-b-3xl flex-1 relative">
      <div className="relative z-20 flex h-full flex-col justify-center gap-3 p-5">

        {/* Floating Logo */}
        <div className={`absolute top-[-12%] right-0 mx-4 rounded-xl border border-gray-200/50 bg-white/98 px-4 py-3 shadow-xl backdrop-blur-md transition-all duration-300 ${isMouseOver ? 'scale-105 shadow-2xl' : 'scale-100'}`}>
          <div className="h-[40px] w-[133px]">
            <Image
              src={clientLogo}
              alt={`${clientName} logo`}
              fill
              className="object-contain"
            />
          </div>
        </div>

        <h4 className="mt-2 font-bold text-lg tracking-tight text-gray-800">
          {country}
        </h4>

        {/* THIS IS THE 100% WORKING LINE-CLAMP */}
       <div className="line-clamp-2 text-sm leading-relaxed text-gray-600 
  overflow-hidden 
  [display:-webkit-box] 
  [-webkit-line-clamp:2] 
  [-webkit-box-orient:vertical]">
  {description}
</div>
        {/* Do NOT wrap in <h5>, <div>, or anything else — just <p> or raw text inside a div with line-clamp */}

        <div className="text-xs font-medium tracking-wide text-gray-500">
          <span className="inline-block rounded-full bg-gray-100/80 px-3 py-1">
            #{hashTag}
          </span>
        </div>
      </div>
    </div>
  </div>

  {/* Hover Overlay with Name + Arrow */}
  <div className={`pointer-events-none absolute inset-0 rounded-3xl bg-gradient-to-br from-white/90 via-white/80 to-white/70 backdrop-blur-lg border border-white/50 shadow-2xl transition-all duration-500 ${isMouseOver ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
    <div className="flex h-full flex-col items-center justify-center text-center">
      <h3 className={`font-bold text-xl tracking-tight text-gray-800 transition-all duration-300 ${isMouseOver ? 'scale-105' : ''}`}>
        {clientName}
      </h3>
      <div className={`mt-4 transition-all duration-300 ${isMouseOver ? 'translate-x-3 opacity-100' : 'opacity-0'}`}>
        <svg width="55" height="40" viewBox="0 0 65 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.92578 24.856H63.0256M63.0256 24.856L33.6977 1.03467M63.0256 24.856L33.6977 48.6773" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  </div>
</div>
  )
}
